import { SiteValuesOptions } from "../models/site";
import axiosConfig from "./axiosConfig";

const getSiteValues = async (authToken: string): Promise<SiteValuesOptions> => {
  const { data } = await axiosConfig.get(`/site/values`, {
    headers: {
      Authorization: `Bearer ${authToken}`,
    },
  });
  return data;
};

export default getSiteValues;
